// Fiche technique HP (sections/specs-hp.liquid, brief "FT" 2026-08-13).
// - Reactif au tamis choisi dans le configurateur (evenement
//   "hexagon:surface-change", meme evenement que assets/specifications.js) :
//   visuel de gauche (bloc_specs_*.png), Surface de frappe, Noyau, Poids,
//   position de la ligne/label "Equilibre" sur le schema, et sa valeur dans
//   le bloc Label/Valeur au-dessus de Poids (RETOURS 1, 2026-08-14 ter : la
//   ligne+label reviennent sur le schema, seule la VALEUR reste au-dessus de
//   Poids — RETOURS 2 avait retire les 2 par erreur).
// - Interactivite hover/clic (points <-> legendes) + animation d'entree :
//   repris de l'ancien <script> inline de sections/specifications.liquid,
//   adapte aux classes .specs-hp*.
(function () {
  var root = document.querySelector('.specs-hp');
  if (!root) return;

  var DATA = window.HexagonSpecsHpData || { cadre: {}, tamis: {} };
  var IMAGES = window.HexagonSpecsHpImages || {};

  // Position (top, en % du schema) de la ligne/label "Equilibre" par tamis —
  // Controle = bas (proche du manche), Puissance = haut (proche du tamis).
  var BALANCE_Y = { cc: 52, mc: 57, lin: 62 };

  function setText(selector, text) {
    if (!text) return;
    root.querySelectorAll(selector).forEach(function (el) { el.textContent = text; });
  }

  function render(id) {
    var data = DATA.tamis[id] || DATA.tamis.mc;
    if (!data) return;

    var photo = root.querySelector('[data-specs-hp-photo]');
    if (photo && IMAGES[id]) photo.src = IMAGES[id];

    setText('[data-specs-value="surfaceDeFrappe"]', data.surfaceDeFrappe);
    setText('[data-specs-value="noyau"]', data.noyau);
    setText('[data-specs-value="poids"]', (data.poids || '').trim());

    if (data.equilibreType || data.equilibreCm) {
      setText('[data-specs-value="equilibre"]', (data.equilibreType || '') + ' — ' + (data.equilibreCm || '') + ' cm');
    }

    var y = BALANCE_Y[id] != null ? BALANCE_Y[id] : BALANCE_Y.mc;
    var line = root.querySelector('[data-specs-balance-line]');
    if (line) {
      line.setAttribute('y1', y);
      line.setAttribute('y2', y);
    }
    var label = root.querySelector('[data-specs-balance-left]');
    if (label) label.style.top = y + '%';
  }

  document.addEventListener('hexagon:surface-change', function (e) {
    render(e.detail.surface);
  });

  render('mc');

  root.classList.add('is-js-ready');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.add('is-animated');
  } else {
    var entranceObserver = new IntersectionObserver(function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        root.classList.add('is-animated');
        currentObserver.unobserve(root);
      });
    }, { threshold: 0.22 });
    entranceObserver.observe(root);
  }

  // 2026-08-13 : hover/clic uniquement pour reveler le texte marketing
  // (.specs-hp__marketing, seulement present sur Cadre/Manche) — masque en
  // CSS sous 990px (voir base.css), donc sans effet sur mobile meme si les
  // handlers restent actifs (pas de complexite supplementaire a les
  // desactiver en JS, le CSS suffit a garantir "aucune animation mobile").
  //
  // RETOURS 1 (2026-08-14 ter) — bug "truc bizarre" au toucher des traits
  // sur mobile : sur un appareil tactile, un tap declenche mouseenter PUIS
  // click coup sur coup ; mouseenter activait deja le point, donc click
  // voyait "isAlreadyActive" et le desactivait aussitot (flash actif/inactif
  // en un seul tap). Fix : mouseenter/mouseleave/focus/blur seulement sur
  // les appareils qui supportent reellement le survol (hover: hover) —
  // le tactile ne garde que click/tap + clavier.
  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var interactiveItems = [].slice.call(root.querySelectorAll(
    '.specs-hp__copy[data-specs-key], .specs-hp__material-point[data-specs-key], .specs-hp__material-hit[data-specs-key]'
  ));
  var clearActiveTimer;

  function setActivePoint(key) {
    root.querySelectorAll('[data-specs-key]').forEach(function (item) {
      item.classList.toggle('is-active', item.dataset.specsKey === key);
      item.classList.toggle('is-muted', Boolean(key) && item.dataset.specsKey !== key);
    });
  }

  interactiveItems.forEach(function (item) {
    var key = item.dataset.specsKey;
    if (supportsHover) {
      item.addEventListener('mouseenter', function () {
        window.clearTimeout(clearActiveTimer);
        setActivePoint(key);
      });
      item.addEventListener('mouseleave', function () {
        clearActiveTimer = window.setTimeout(function () { setActivePoint(''); }, 45);
      });
      item.addEventListener('focus', function () {
        window.clearTimeout(clearActiveTimer);
        setActivePoint(key);
      });
      item.addEventListener('blur', function () {
        clearActiveTimer = window.setTimeout(function () { setActivePoint(''); }, 45);
      });
    }
    item.addEventListener('click', function () {
      var isAlreadyActive = item.classList.contains('is-active');
      setActivePoint(isAlreadyActive ? '' : key);
    });
    if (item.getAttribute('role') === 'button') {
      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        item.click();
      });
    }
  });
})();
